import {largeMonths} from '@/helpers/enums'
import moment from "moment";

const months = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre"
]

function getDaysByYearAndMonth (year, month) {
  let date = new Date(year, month - 1, 1);
  let currentDate = new Date();
  let currentYear = currentDate.getFullYear();
  let currentMonth = (currentDate.getMonth() + 1);
  let currentDay = currentDate.getDate();
  let firstDayOfMonth = 1;
  let result = [];
  let day = 0;

  if (parseInt(year) == currentYear && parseInt(month) == currentMonth) {
    while(firstDayOfMonth <= currentDay) {
      day = firstDayOfMonth++;

      if(day.toString().length <= 1)
        day = `0${day}`;

      result.push(day.toString());
    }
  } else {
    while (date.getMonth() == month - 1) {
      day = date.getDate();
  
      if(day.toString().length <= 1)
        day = `0${day}`;
  
      result.push(day.toString());
      date.setDate(date.getDate() + 1);
    }
  }

  return result;
}

function getMonthsOfYear(yearSelected){
  let date = new Date();
  let numericMonths = [];
  let stringMonths = [];
  let firstMonthOfYear = 1;
  let currentYear = date.getFullYear();
  let currentMonth = (date.getMonth() + 1);

  if (parseInt(yearSelected) == currentYear) {
    while (firstMonthOfYear <= currentMonth) {
      let month = firstMonthOfYear++;
      if (month.toString().length < 2) {
        month = `0${month}`
      }
      numericMonths.push(month.toString());
    }
    if (numericMonths.length > 0)
      numericMonths.forEach(e => stringMonths.push(largeMonths[e])); 
  } else {
    stringMonths = months;
  }

  return stringMonths;
}


function getRangeOfYears(maxYears) {
  let date = new Date();
  let years = [];

  let currentYear = date.getFullYear();
  let startYear = currentYear - maxYears;

  while (startYear <= currentYear) {
    let year = startYear++;
    years.push(year.toString());
  }

  return years.reverse();
}

function createDateStringByYearMonthDay(year, month, day) {
  let date = `${year}-${month}-${day}`;
  return date;
}

function getAge(stringDate) {
  let date = new Date();
  let stringDateSplit = stringDate.split('-');
  let currentYear = date.getFullYear();
  let currentMonth = (date.getMonth() + 1);
  let currentDay = date.getDate();

  let age = currentYear - parseInt(stringDateSplit[0]);

  if (parseInt(stringDateSplit[1]) > currentMonth) {
    age--;
  }

  if (parseInt(stringDateSplit[1]) == currentMonth) {
    if (parseInt(stringDateSplit[2]) > currentDay) {
      age--;
    }
  }

  return age;
}

function getYearsElapsedBetweenTwoDates(firstDate, secondDate) {
  const firstDateConverted = moment(firstDate).format("YYYY-MM-DD");
  const secondDateConverted = moment(secondDate).format("YYYY-MM-DD");

  if (firstDateConverted == 'Invalid date' || secondDateConverted == 'Invalid date' ) 
    throw "Invalid dates";
  
  const dateArrayInAscendingOrder = sortDatesInAscendingOrder([firstDateConverted, secondDateConverted]);

  const minDate = dateArrayInAscendingOrder[0];
  const maxDate = dateArrayInAscendingOrder[1];

  const stringMinDateSplit = minDate.split('-');
  const secondMaxDateSplit = maxDate.split('-');

  const dayMinDate = parseInt(stringMinDateSplit[2]);
  const monthMinDate = parseInt(stringMinDateSplit[1]);
  const yearMinDate = parseInt(stringMinDateSplit[0]);

  const dayMaxDate = parseInt(secondMaxDateSplit[2]);
  const monthMaxDate = parseInt(secondMaxDateSplit[1]);
  const yearMaxDate = parseInt(secondMaxDateSplit[0]);
  
  let years = yearMaxDate - yearMinDate;

  if (monthMinDate > monthMaxDate) {
    years--;
  }

  if (monthMinDate == monthMaxDate) {
    if (dayMinDate > dayMaxDate) {
      years--;
    }
  }
  
  return years;
}

function sortDatesInAscendingOrder(dates) {
  return dates.sort((a,b) => {
    return Date.parse(a) - Date.parse(b);
  })
}

function isUnderAge(age, minAge) {
  return age >= minAge ? false : true;
}

function compareTwoDates(dateOne, dateTwo) {
  if (Date.parse(dateOne) > Date.parse(dateTwo)) {
    return true;
  }

  return false;
}

function getCurrentDate() {
  var today = new Date();
  var month = today.getMonth() + 1; //months from 1-12
  var day = today.getDate();
  var year = today.getFullYear();
  
  if (month.toString().length < 2)
      month = '0' + month;
  if (day.toString().length < 2) 
      day = '0' + day;

  return `${year}-${month}-${day}`;
}

export {
  getDaysByYearAndMonth,
  getMonthsOfYear,
  getRangeOfYears,
  createDateStringByYearMonthDay,
  getAge,
  getYearsElapsedBetweenTwoDates,
  sortDatesInAscendingOrder,
  isUnderAge,
  compareTwoDates,
  getCurrentDate
}